<!--
 * @Descripttion: 修改了一些内容
 * @version: v1.0
 * @Author: htt
 * @Date: 2021-09-24 16:16:55
 * @LastEditors: htt
 * @LastEditTime: 2021-12-09 14:48:54
-->
<template>
  <el-dialog
    :title="!dataForm.id ? '新增' : '修改'+'场地'"
    :close-on-click-modal="false"
    :before-close="handleClose"
    :visible.sync="visible"
    width="800px"
    height="456px"
    class="info-dialog"
  >
    <el-form :model="dataForm" :rules="rules" ref="dataForm" label-width="150px" class="demo-ruleForm">

      <el-form-item label="场地名称" prop="name">
        <el-input v-model="dataForm.name"></el-input>
      </el-form-item>
      <el-form-item label="场地编码" prop="code">
        <el-input v-model="dataForm.code"></el-input>
      </el-form-item>
      <el-form-item label="所属区域" prop="regionCode">
        <el-select v-model="dataForm.regionCode" :disabled="dataForm.regionCode!=''" placeholder="请选择区域">
          <el-option v-for="(item,index) in regionTreeList"
                     :key="index"
                     :label="item.name"
                     :value="item.id">
          </el-option>
        </el-select>
      </el-form-item>
      <el-form-item prop="fieldFloor" label="场地楼层：">
        <el-select v-model="dataForm.fieldFloor" placeholder="请选择" @change="onfloorChange">
          <el-option
              v-for="item in filedFloorOptions"
              :key="item.id"
              :label="item.floorName"
              :value="item.id">
          </el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="场地属性" prop="properties" class="row-info">
        <el-checkbox-group v-model="dataForm.properties">
          <el-checkbox v-for="item in applyTypeList" :label="item.id">{{item.text}}</el-checkbox>
        </el-checkbox-group>
      </el-form-item>
      <el-form-item label="场地类型" prop="type">
        <el-select v-model="dataForm.type" placeholder="请选择场地">
          <el-option v-for="(item,index) in placeTypeList"
                     :key="index"
                     :label="item.text"
                     :value="item.id">
          </el-option>
        </el-select>
      </el-form-item>

      <el-form-item label="容纳人数" prop="capacity">
        <el-input-number v-model.number="dataForm.capacity" :min="0" type="number"></el-input-number>
      </el-form-item>
      <el-form-item label="机位数" prop="machines">
        <el-input-number v-model.number="dataForm.machines" :min="0" type="number"></el-input-number>
      </el-form-item>
      <el-form-item label="半天机位数" prop="halfMachines">
        <el-input-number v-model.number="dataForm.halfMachines" :min="0" type="number"></el-input-number>
      </el-form-item>
      <el-form-item label="每半天可用数" prop="halfDayTimes">
        <el-input-number v-model.number="dataForm.halfDayTimes" :min="0" type="number"></el-input-number>
      </el-form-item>
      <el-form-item label="摄像头数量" prop="cameras">
        <el-input-number v-model.number="dataForm.cameras" :min="0" type="number"></el-input-number>
      </el-form-item>
      <el-form-item label="摄像头开启情况" prop="cameraStatus">
        <el-switch :active-value="1" :inactive-value="0" v-model="dataForm.cameraStatus"></el-switch>
      </el-form-item>
      <el-form-item label="保密性" prop="secrecyStatus">
        <el-radio-group v-model="dataForm.secrecyStatus">
          <el-radio :label="0">公开</el-radio>
          <el-radio :label="1">保密</el-radio>
        </el-radio-group>
      </el-form-item>
      <el-form-item label="配套硬件设备" prop="supporting" class="row-info">
        <el-checkbox-group v-model="dataForm.supporting">
          <el-checkbox v-for="(item,index) in supportingList" :key="index" :label="item.id" name="type">{{item.text}}</el-checkbox>
        </el-checkbox-group>
      </el-form-item>
      <el-form-item label="排序" prop="sort">
        <el-input-number v-model.number="dataForm.sort" :min="0" type="number"></el-input-number>
      </el-form-item>
    </el-form>

    <span slot="footer" class="dialog-footer">
      <el-button @click="visible = false">取消</el-button>
      <el-button v-preventReClick type="primary" @click="dataFormSubmit()">提交</el-button>
    </span>
  </el-dialog>
</template>

<script>
import {
  infoMaintainDetail,
  infoMaintainSave,
} from '@/server/field'
import {mapState} from "vuex";
export default {
  data(vm) {
    return {
      visible: false,
      dataForm: {
        id: '',
        tradeOrgId: '',
        fieldFloor:'',
        floorName:'',
        regionCode:'',
        regionName: '',
        name: '',
        type:'',
        fieldTypeName: '',
        capacity: '',
        halfDayTimes: '',
        cameras: '',
        cameraStatus:'',
        supporting:[],
        secrecyStatus:0,
        secrecyStatusName:'',
        machines:'',
        halfMachines:'',
        code:'',
        properties:[],

        sort: 0,
      },
      rules: {
        fieldFloor: [
          { required: true, message: '请填写场地楼层', trigger: ['blur','change'] }
        ],
        regionCode: [
          { required: true, message: '请选择活动区域', trigger: 'change' }
        ],
        name: [
          { required: true, message: '请输入场地名称', trigger: 'blur' },
        ],
        type: [
          { required: true, message: '请选择场地类型', trigger: 'change' }
        ],
        capacity: [
          { required: true, message: '请输入可容纳人数', trigger: 'blur' }
        ],
        halfDayTimes: [
          { required: true, message: '请输入每半天可用数', trigger: 'blur' }
        ],
        cameras: [
          { required: true, message: '请输入摄像头数量', trigger: 'blur' }
        ],
        cameraStatus: [
          { required: true, message: '请选择是否开启摄像头', trigger: 'blur' }
        ],
        secrecyStatus: [
          { required: true, message: '请选择保密性', trigger: 'change' }
        ],
        machines: [
          { required: true, message: '请输入机位数', trigger: 'blur' }
        ],
        halfMachines: [
          { required: true, message: '请输入半天机位数', trigger: 'blur' }
        ],
        code: [
          { required: true, message: '请输入场地编码', trigger: 'blur' }
        ],
        properties: [
          { required: true, message: '请选择场地属性', trigger: ['change'] }
        ],
        sort: [
          { required: true, message: '请输入排序', trigger: 'blur' }
        ],
      },
      fieldTypeOptions:[],//类型
      filedFloorOptions:[],//楼层
    }
  },
  created() {
    this.$store.dispatch('region/getRegionTree','');
    this.$store.dispatch('region/getPlaceType','');
    this.$store.dispatch('region/getSupportingList');
    this.$store.dispatch('region/getApplyTypeList');
  },
  computed:{
    ...mapState({
      regionTreeList:(state) => state.region.regionTreeList,
      placeTypeList:(state) => state.region.placeTypeList,
      supportingList:(state) => state.region.supportingList,
      applyTypeList:(state) => state.region.applyTypeList,
    })
  },
  methods: {
    handleClose() {
      this.visible = false
    },
    init(id, tradeOrgId,regionCode) {
      this.visible = true
      this.dataForm.id = id || ''
      this.dataForm.tradeOrgId = tradeOrgId
      this.dataForm.regionCode = regionCode
      this.getFloors();
      this.$nextTick(() => {
        this.$refs['dataForm'].resetFields()
        if (this.dataForm.id) {
          infoMaintainDetail(id).then(res => {
            if (res.data.code === '1') {
              res.data.data.supporting = res.data.data.supporting?res.data.data.supporting.split(','):[]
              res.data.data.properties = res.data.data.properties?res.data.data.properties.split(','):[]
              this.dataForm = res.data.data ? res.data.data : {}

            } else {
              this.$message.error(res.data.msg)
            }
          })
        }
      })
    },
    // 表单提交
    dataFormSubmit() {
      this.$refs['dataForm'].validate((valid) => {
        if (valid) {
          this.dataForm.supporting = this.dataForm.supporting.join(',')
          this.dataForm.properties = this.dataForm.properties.join(',')
          infoMaintainSave(this.dataForm).then(res => {
            if (res.data.code === '1') {
              this.$message.success(res.data.msg)
              this.visible = false
              this.$emit('refreshDataList')
            } else {
              this.$message.error(res.data.msg)
              this.visible = false
            }
          })
        }
      })
    },
    getFloors(){
      this.$http.post('/field/floors/list',{filter:{tradeOrgId:this.dataForm.tradeOrgId},page:1,rows:100}).then(res => {
        this.filedFloorOptions = res.data.rows;
      })
    },
    onfloorChange(val){
      let list=this.filedFloorOptions.filter(it=>it.id==val);
      this.dataForm.floorName= list&&list.length>0?list[0].floorName:""
    }
  }
}
</script>

<style lang="scss" scoped>
  .info-dialog{
    .demo-ruleForm{
      display: flex;
      flex-wrap:wrap;
      padding: 0;
      .el-form-item{
        width: 50%;
        /deep/.el-input--medium .el-input__inner{
          width: 200px;
        }
      }
      .row-info{
        width: 100% !important;
      }
    }
  }

</style>
